var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h5Image"},[_c('van-image',{attrs:{"width":"100%","height":"100%","src":_vm.src},on:{"click":_vm.openPop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }